import { PropsWithChildren, useCallback, useMemo } from 'react'

import { STATSIG_EXPERIMENTS, STATSIG_EXPERIMENTS_CONFIG } from '../../config/statsig-experiments.config'

import { StatsigInitContext } from './statsig.context'

export function StatsigUserAgnosticProvider({ children }: PropsWithChildren) {
  const getExperimentBucket = useCallback((experimentKey: STATSIG_EXPERIMENTS | null) => {
    if (!experimentKey) return null
    return STATSIG_EXPERIMENTS_CONFIG[experimentKey].defaultBucket
  }, [])
  const value = useMemo(() => ({ init: false, getExperimentBucket }), [])
  return <StatsigInitContext.Provider value={value}>{children}</StatsigInitContext.Provider>
}
